import TotalKneeReplacement from "../../../images/Knee/Bilateral Total Knee Pre-op.png";
import UKAPreOp from "../../../images/Knee/UKA Pre-op.png";
export default function KneeReplacementDifferentTypes() {
  return (
    <div className="row KneeReplacementDifferentTypes shared-margin">
      <div className="col l10 offset-l1">
        <div className="col l6 left-side">
          <img className="z-depth-1" src={TotalKneeReplacement} alt="" />
          <img className="z-depth-1" src={UKAPreOp} alt="" />
        </div>
        <div className="col l6 right-side">
          <h6>
            <u>Are there different types of knee replacements?</u>
          </h6>
          <p>
            There are 2 main types of knee replacements. A partial knee
            replacement or a full knee replacement. <br></br> <br></br> A partial knee replacement
            is typically done when only 1 compartment (area) of your knee is
            worn. This is usually the medial side (where the knees touch each
            other) of the knee and would typically result in pain on the inside
            of the knee and you may also have increased bowing (legs like a
            cowboy) of your legs as the wear gets more severe. The advantages of
            a partial knee replacement include higher satisfaction, faster
            recovery and less risk than a full knee replacement. The main
            disadvantage is an increased risk of revision (needing to do the
            full knee replacement surgery some years down the road). 
            
            <br></br> <br></br>
            A full knee replacement is done when more than compartment of your knee has
            arthritis. This involves replacing the tibial surface (leg bone) and
            the femoral surface (thigh bone) with metal components and a plastic
            spacer between the two. In some cases your patella (kneecap) may be
            replaced as well. The advantages of a full knee replacement include
            an 85% rate of satisfaction with improved function and pain relief,
            allowing you to return to your life and activities. As with any
            surgery there are risks and these are discussed here (add blue click
            to transport them to the risks of replacement section).
          </p>
        </div>
      </div>
    </div>
  );
}
